// phonics_data_lt09.js
// Letter Teams L09 - L9 Long Vowel Sounds ee, ea
// 路由：/phonics/lt09

const MEDIA_BASE = '/media/phonics/lt09';
const V = 'v1';

export const letterDataLt09 = {
  id: 'lt09',
  letter: 'L09',
  title: 'L9 Long Vowel Sounds ee, ea',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It is time to sleep.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The pals have dreams.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Look!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Pink drives a jeep.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "The jeep drives fast.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Oh!", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Yellow has a pretty dress.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "She has a pretty cape too.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "It is time for tea.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Look!", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Red is in the sea.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "This is a nice sea.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "He plays with seals.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Yum!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Blue has ice cream.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "I love ice cream.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Here comes a bee!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Oh no!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "A bad dream!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "Now Blue sleeps again.", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
        { en: "Sweet dreams!", audioEn: `${MEDIA_BASE}/story3_8.mp3?${V}` },
      ],
    },
  ],
};
